
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import uploadInvoice from './components/uploadInvoice.vue';
  import {
    orderorderInvoiceDetail
  } from "@/api/order"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      uploadInvoice
    }
  })

  export default class ProductList extends Vue {
    private info:any = {}
    private pageloading = false
    private success = 'https://cdn2024.routuan.com/routuanapp/success-icon.png'
    private notInvoiced = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/8cecee1e72555e217f8b2afd8a3467b.png'
    private uploadShow = false
    private uploadType = 1

    private mounted () {
      this.getInfo()
    }

    private tocopy(e,row){
      let text = ''
      text += '发票抬头：' + row.RecipientName +'\n'
      text += '税号：' + row.VATNumber  +'\n'
      text += '公司地址：' + row.CompanyAddress  +'\n'
      text += '公司电话：' + row.CompanyPhone  +'\n'
      text += '开户行：' + row.BankName + row.BranchName  +'\n'
      text += '银行账号；' + row.BankAccountNumber  +'\n'
      text += '开票金额：' + row.InvoiceMoney  +'\n'
      text += '订单编号：' + row.OrderNo  +'\n'
      text += '下单人：' + row.CustomerName  +'\n'
      text += '下单时间：' + row.OrderAddTime  +'\n'
      text += '商品明细：'
      for(let item of row.OrderDetailList){
        text+=item.ProductName+'*'+item.ProductCount+';'
      }
      text +='\n'
      text += '开票状态：' + (row.InvoiceState==0?'待开票':'已开票')  +'\n'
      
      handleClipboard(text,e)
    }
    private async getInfo(){
      try{
        this.pageloading = true
        let res:any = await orderorderInvoiceDetail({
          Keywords:'',
          ...this.$route.query
        })
        if(res.IsSuccess){
          this.info = res.Result
        }
      }finally{
        this.pageloading = false
      }
    }
  }
